import {Link} from 'react-router-dom';
import React, { /*useContext, useEffect, useState, useRef*/ } from 'react';
//import {Link} from 'react-router-dom';
import {useracc, postApi, consoleLog} from './functions';
//import {UserContext} from '../utils/usercontext';
import EventEmitter from './emmiter';
import io from 'socket.io-client';
import axios from 'axios';
//import {keyfriends} from './protectedroutes';

import {UserContext} from './usercontext';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../routes/components/fontawesome/fontawesome';

//import ReactAudioPlayer from 'react-audio-player';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

//import '../routes/css/socketplayer.css';
import Button from 'react-bootstrap/Button';
import { ButtonGroup } from 'react-bootstrap';

var socket;
var sockets;

export default class RadioBroadcasterSocket extends React.Component {
  constructor(props) {
    super(props);
		this.state = {
			connected: false,
			livemode: process.env.NODE_ENV==="development"?false:true,

			//---- rtmp
			rtmp: {path: '', width: 0, height: 0, fps: 0, videorate: 0, audiorate: 0},

			//---- Audio Player
			audioplayer: null,
			//audioid: 0,
			audiodata: {},
			audioState: {
				id: 0,
				currentTime: 0,
				duration: 0,
				buffered: 0,
				pause: false,
				replay: false,
				repeat: false,
				favorite: false,
				like: false,
			},
			audioPos: 0,
			showVolume: 0,
			volumeDrag: false,
			volume: 100,
			volumetimer: null,
			AudioListener: null,
			AudioListener1: null,
			//audioPaused: true,
			//audioRepeat: false,
			//audioBuffered: 0,
			//audioCurrentTime: 0,
			//audioDuration: 0,

			//---- Listeners

			//---- Template Listeners
			TemplateRegister: null,

		};
		socket = io(process.env.NODE_ENV==="production"?process.env.REACT_APP_SOCKET:process.env.REACT_APP_LIVEMODE==="live"?process.env.REACT_APP_SOCKET:process.env.REACT_APP_SOCKET_TEST);
		//this.playNotification = this.playNotification.bind(this);

		this.changeLivemode = this.changeLivemode.bind(this);
		this.displayTime = this.displayTime.bind(this);

		this.audioPause = this.audioPause.bind(this);
		this.audioReplay = this.audioReplay.bind(this);
		this.audioRepeat = this.audioRepeat.bind(this);
		this.audioFavorite = this.audioFavorite.bind(this);
		this.audioLike = this.audioLike.bind(this);
		this.callbackfunction = this.callbackfunction.bind(this);
		this.audioClose = this.audioClose.bind(this);
		this.closeRtmp = this.closeRtmp.bind(this);
	}

	static contextType = UserContext;

	async componentDidMount() {

		//---- Connect to server
		const connectionObject  = {
			secure: true,
			withCredentials: true,
			extraHeaders: {
				'connections': 'keep-alive',
			}
		};
		//await useracc();
		//var params = new URLSearchParams();
		
		socket.current = io.connect(process.env.NODE_ENV==="production"?process.env.REACT_APP_SOCKET:process.env.REACT_APP_LIVEMODE==="live"?process.env.REACT_APP_SOCKET:process.env.REACT_APP_SOCKET_TEST, connectionObject);
		
		//---- Handle server disconnects
		socket.current.on("disconnect", () => {
			this.setState({connected: false},()=>{
				
				EventEmitter.emit('/socket/status', {connected: false});
			});
		});

		//---- Verify Client
		socket.current.on("/socket/verify", async (id) => {
			this.setState({connected: true},()=>{
				EventEmitter.emit('/socket/status', {connected: true});
			});
			socket.current.emit("verification", { id: 'no value' } );
		});
		const SocketReconnect = EventEmitter.addListener('/socket/reconnect', async data => {
			socket.current.disconnect();
			setTimeout(function () {
				if( !socket.current.connected ) socket.current.connect();
				//this.setState({connected: true});
			}, 1500);
			
		}); this.setState({SocketReconnect});

		//---- Re-verify Client
		const SocketClient = EventEmitter.addListener('/client', async data => {
			
			socket.current.emit("/socket/client", data );

			if( !sockets ) sockets = {};

			if( typeof data === 'object' ) {
				
				for( let i in data ) {

					if( !sockets[parseInt(i)] ) {

						let url = data[i].replace('https','wss');
						
						if( !sockets[parseInt(i)] ) sockets[parseInt(i)] = {};
						sockets[parseInt(i)].current = io.connect(url, connectionObject);

						sockets[parseInt(i)].current.on("disconnect", () => {
							this.setState({connected: false},()=>{
								
								EventEmitter.emit('/socket/status', {connected: false});
							});
						});
				
						//---- Verify Client
						sockets[parseInt(i)].current.on("/socket/verify", async (id) => {
							this.setState({connected: true},()=>{
								EventEmitter.emit('/socket/status', {connected: true});
							});
							sockets[parseInt(i)].current.emit("verification", { id: 'no value' } );
						});
						const SocketReconnect = EventEmitter.addListener('/socket/reconnect', async data => {
							sockets[parseInt(i)].current.disconnect();
							setTimeout(function () {
								if( !sockets[parseInt(i)].current.connected ) sockets[parseInt(i)].current.connect();
								//this.setState({connected: true});
							}, 1500);
							
						}); this.setState({SocketReconnect});
				
						//---- Re-verify Client
						const SocketClient2 = EventEmitter.addListener('/client', async data => {
							
							sockets[parseInt(i)].current.emit("/socket/client", data );
						});

						
						//PortalService
						sockets[parseInt(i)].current.on("/service/stage", async (data) => {
							console.log(data);
							EventEmitter.emit('/service/stage', data);
						});
						sockets[parseInt(i)].current.on("/portal/streams", async (data) => {
							EventEmitter.emit('/portal/streams', data);
						});
						sockets[parseInt(i)].current.on("/service/schedule", async (data) => {
							EventEmitter.emit('/service/schedule', data);
						});

						//---- Chatbox
						sockets[parseInt(i)].current.on("/service/chatbox", async (data) => {
							EventEmitter.emit('/service/chatbox', data);
						});

						
						//---- Template
						//---- Introduction
						sockets[parseInt(i)].current.on("/template/introduction", async (data) => {
							EventEmitter.emit('/template/introduction', data);
						});

						//---- Emojis / Emotes
						sockets[parseInt(i)].current.on("/template/emojisemotes", async (data) => {
							console.log(data);
							EventEmitter.emit('/template/emojisemotes', data);
						});
						
						//---- Giphy / Tenor
						sockets[parseInt(i)].current.on("/template/giphytenor", async (data) => {
							EventEmitter.emit('/template/giphytenor', data);
						});

						//---- Chat Message
						sockets[parseInt(i)].current.on("/template/chatmessage", async (data) => {
							EventEmitter.emit('/template/chatmessage', data);
						});

						//---- Handover
						sockets[parseInt(i)].current.on("/template/handover", async (data) => {
							EventEmitter.emit('/template/handover', data);
						});
					}

				}
			}




		}); this.setState({SocketClient});



		

		/*
			---- Portal
		*/
		socket.current.on("/portal/user", async (data) => {
			const value = this.context;
			const getUser = await useracc();
			value.setUser( getUser );
			EventEmitter.emit('/portal/user', data);
		})
		


		/*
			---- Template
		*/
		
		//---- Register
		const TemplateRegister = EventEmitter.addListener('/template/register', data => {
			for(let i in sockets) {
				sockets[i].current.emit("/template/register", data );
			}
			//
		}); this.setState({TemplateRegister});

		//---- Settings overlay, from main API
		socket.current.on("/template/settings", async (data) => {
			EventEmitter.emit('/template/settings', data);
		});

		
		




		//---- Audio Player
		this.setState({audioplayer: new Audio()}, ()=>{

			this.state.audioplayer.addEventListener('timeupdate', (event) => {
				try{
					let audioState = this.state.audioState;
					if( audioState.currentTime !== Math.floor(this.state.audioplayer.currentTime) || audioState.duration !== Math.floor(this.state.audioplayer.duration) || audioState.buffered !== Math.floor(this.state.audioplayer.buffered.end(0)) ) {
						
						audioState.currentTime = Math.floor(this.state.audioplayer.currentTime);
						audioState.duration = Math.floor(this.state.audioplayer.duration);
						audioState.buffered = Math.floor(this.state.audioplayer.buffered.end(0));
						//if( audioState.currentTime > 1 ) audioState.pause = false;

						//this.setState({audioState});
						EventEmitter.emit('/audio/player', audioState);
					}
						
				} catch(error) {}
			}, false);
		});

		const AudioListener = EventEmitter.addListener('/audio/player', async (data) => {

			//---- Store existing content to detect if switching audio
			const old_audio_id = this.state.audioState.id;
			const old_audio_favorite = this.state.audioState.favorite;
			const old_audio_like = this.state.audioState.like;

			//---- Play / pause selected track
			//if( !data.pause || this.state.audioState.id === data.id ) {

				this.setState({audioState: data},async ()=>{

					//---- Play / Pause
					//if( this.state.audioplayer.paused !== data.pause ) {

						if( this.state.audioState.id !== old_audio_id ) {

							var params = new URLSearchParams();
							params.append('id', data.id);
		
							const x = await postApi('/v3/audio/', params);
							
							this.setState({audiodata: x.data.audio});
		
							//---- TEST STATE
							this.state.audioplayer.autoplay = true;
							this.state.audioplayer.preload = 'auto';
							this.state.audioplayer.src = '/audio/'+x.data.audio.code+'/'+x.data.audio.shortname;

							data.currentTime = 0;
							this.setState({audioState: data});
							

						} else {
							data.pause?this.state.audioplayer.pause():this.state.audioplayer.play();
						}

						


					//}

					//---- Seek
					if( data.currentTime < this.state.audioplayer.currentTime - 3 || data.currentTime > this.state.audioplayer.currentTime + 3 ) {
						this.state.audioplayer.currentTime = data.currentTime;
					}

					//---- Replay
					if( data.replay ) {
						let audioState = this.state.audioState;
						audioState.currentTime = 0;
						audioState.replay = false;
						EventEmitter.emit('/audio/player', audioState);
					}

					//---- Repeat
					if( data.repeat && !this.state.audioplayer.loop ) this.state.audioplayer.loop = true;
					if( !data.repeat && this.state.audioplayer.loop ) this.state.audioplayer.loop = false;

					//---- Favorite, Like
					const user = this.context;
					if( user.user.user.rank > 1 ) {
						if( data.favorite !== old_audio_favorite || data.like !== old_audio_like ) {
							var params = new URLSearchParams();
							params.append('id', data.id);
							params.append('favorite', data.favorite?1:0 );
							params.append('like', data.like?1:0 );
							await postApi('/v3/audio/stats', params);
						}
					}

					/*---- TEST Seek
					if( data.currentTime < this.state.audioplayer.currentTime - 3 || data.currentTime > this.state.audioplayer.currentTime + 3 ) {
						this.state.audioplayer.currentTime = data.currentTime;
					}
					*/

					//---- Replay
					/*if( data.replay ) {
						let audioState = this.state.audioState;
						audioState.currentTime = 0;
						audioState.replay = false;
						EventEmitter.emit('/audio/player', audioState);
					}*/

					/*---- TEST Repeat
					if( data.repeat && !this.state.audioplayer.loop ) this.state.audioplayer.loop = true;
					if( !data.repeat && this.state.audioplayer.loop ) this.state.audioplayer.loop = false;
					*/

					//---- Favorite, Like
					/*const user = this.context;
					if( user.user.user.rank > 1 ) {
						if( data.favorite !== old_audio_favorite || data.like !== old_audio_like ) {
							var params2 = new URLSearchParams();
							params2.append('id', data.id);
							params2.append('favorite', data.favorite?1:0 );
							params2.append('like', data.like?1:0 );
							await postApi('/v3/audio/stats', params2);
						}
					}*/
						
				});
			//}
		}); this.setState({AudioListener});

		socket.current.on("/audio/stats", data => {
			EventEmitter.emit('/audio/stats', data);
		});

		socket.current.on("/chatlive/emoji", data => {
			EventEmitter.emit('/chatlive/emoji', data);
		});

	}

	componentWillUnmount() {
		
		if( this.state.TemplateRegister) this.state.TemplateRegister.remove();
	}

	changeLivemode() {
		this.setState({livemode: !this.state.livemode},()=>{
			if( this.state.livemode ) {
				axios.defaults.baseURL = process.env.REACT_APP_API;
				socket.disconnect();
				//process.env.NODE_ENV==="development"?process.env.REACT_APP_SOCKET_TEST:process.env.REACT_APP_SOCKET
			} else {
				axios.defaults.baseURL = process.env.REACT_APP_API_TEST;
				socket.disconnect();
			}
		});
	}

	playNotification(override=false) {
	}



	async audioLoad() {

	}
	async audioUnload() {

	}
	async audioPause() {
		let audioState = this.state.audioState;
		audioState.pause = !audioState.pause;
		EventEmitter.emit('/audio/player', audioState);
		//this.setState({audioState});

		/*if( this.state.audioplayer.paused ) this.state.audioplayer.play(); else this.state.audioplayer.pause();
		let audioState = this.state.audioState;
		audioState.pause = this.state.audioplayer.paused;
		this.setState({audioState});*/

	}
	async audioSeek(event) {
		try{
			const user = this.context;
			if( user.user.user.rank < 4 ) return;
			let percent = (event.clientX - event.target.getBoundingClientRect().left) / event.target.getBoundingClientRect().width;
			let audioState = this.state.audioState;
			audioState.currentTime = Math.floor(percent*this.state.audioplayer.duration);
			EventEmitter.emit('/audio/player', audioState);	
			//this.state.audioplayer.currentTime = percent*this.state.audioplayer.duration;
		} catch(error){consoleLog(error)}
	}
	audioSeekPos(event) {
		//if( user.user.user.rank < 4 ) return;
		let percent = (event.clientX - event.target.getBoundingClientRect().left) / event.target.getBoundingClientRect().width;
		this.setState({audioPos: Math.floor(percent*this.state.audiodata.length)})
	}
	async audioReplay() {
		let audioState = {...this.state.audioState};
		audioState.replay = true;
		EventEmitter.emit('/audio/player', audioState);
	}
	async audioRepeat() {
		let audioState = {...this.state.audioState};
		audioState.repeat = !audioState.repeat;
		EventEmitter.emit('/audio/player', audioState);
	}
	async audioFavorite() {
		let audioState = {...this.state.audioState};
		audioState.favorite = !audioState.favorite;
		EventEmitter.emit('/audio/player', audioState);
	}
	async audioLike() {
		let audioState = {...this.state.audioState};
		audioState.like = !audioState.like;
		EventEmitter.emit('/audio/player', audioState);
	}

	async audioVolume() {

	}

	async audioClose() {
		let audioState = this.state.audioState;
		audioState.id = 0;
		audioState.pause = true;
		EventEmitter.emit('/audio/player', audioState);
	}

	displayTime(time) {
		try{
			var date = new Date(null);
			date.setSeconds(time); // specify value for SECONDS here
			var result = date.toISOString().substr(11, 8);
			return result;
		}catch(error) { return "00:00:00"; }
	}

	
	showVolume(event) {
		if( event === 0 ) {
			this.state.volumetimer = setTimeout(()=>{this.setState({showVolume: 0});}, 3000);
		} else {
			clearTimeout(this.state.volumetimer);
			this.setState({showVolume: event});
		}
	}
	setVolume(event) {
		try{
			/* TEST
			let percent = 1-((event.clientY - event.target.getBoundingClientRect().top) / event.target.getBoundingClientRect().height);
			this.state.audioplayer.volume = Number(percent).toFixed(1);
			this.setState({volume: Number(percent).toFixed(1)*100});
			*/
		} catch(error){consoleLog(error)}
	}
	setVolumeDown(event) {
		this.setState({volumeDrag: true});
	}
	setVolumeMove(event) {
		if( this.state.volumeDrag ) {
			let top = event.clientY - event.target.getBoundingClientRect().top;
			if( top < 200 ) top = 200;
			if( top > 280 ) top = 280;
			let percent = 1-((top-200)/80);
			this.state.audioplayer.volume = Number(percent).toFixed(1);
			this.setState({volume: Number(percent).toFixed(1)*100});
		}
	}
	setVolumeUp(event) {
		this.setState({volumeDrag: false});
	}

	callbackfunction() {
		
	}

	closeRtmp() {
		let x = this.state.rtmp;
		x.width = 0;
		this.setState({rtmp: x});
	}


	render() {
		const user = this.context;
		return (
			<>
				{this.state.audioState.id!==0&&
					<div className="socketplayer">
						<div className="socketplayer-inner">
							{/*this.state.connected?'True':'False'*/}
							<div className="container pt-2 text-white">
								<Row>

									<div className="p-0 d-none d-lg-block" style={{width: 62}}>
										<div className="socketplayer-avatar">
											<img src={`https://mix365.co.uk${this.state.audiodata.avatar}`} alt="profile avatar" />
										</div>
									</div>

									<Col className="d-none d-lg-block text-vertical socketplayer-showname">
										<div>
											{this.state.audiodata.showname}<br />
											<div className="socketplayer-genres">
												{this.state.audiodata?.genres && this.state.audiodata.genres.length > 0 &&
													Object.keys(this.state.audiodata.genres).map((f,j) => {
														return (
															<React.Fragment key={j}><span >#{this.state.audiodata.genres[f]}</span>&nbsp;</React.Fragment>
														)
													})
												}
											</div>
										</div>
									</Col>

									<div className="d-none d-lg-block text-vcenter socketplayer-showname" style={{width:250}}>
										<Row className="gx-0">
											<div style={{width:240}}>
												<ul className="socketplayer-icongrid">
													<li className="audio-cursor" onClick={this.audioPause}>
														{this.state.audioState.pause?
															<OverlayTrigger key="play" placement="top" overlay={
																	<Tooltip id="tooltip-play">Play Track</Tooltip>
																}><FontAwesomeIcon icon="play" />
															</OverlayTrigger>
														:
															<OverlayTrigger key="pause" placement="top" overlay={
																	<Tooltip id="tooltip-pause">Pause Track</Tooltip>
																}><FontAwesomeIcon icon="pause" />
															</OverlayTrigger>
														}
													</li>
													<li className="audio-cursor" onClick={this.audioReplay}>
														<OverlayTrigger key="replay" placement="top" overlay={
																<Tooltip id="tooltip-replay">Replay Track</Tooltip>
															}><FontAwesomeIcon icon="redo" />
														</OverlayTrigger>
													</li>
													<li className="audio-cursor" onClick={this.audioRepeat}>
														<OverlayTrigger key="restart" placement="top" overlay={
																<Tooltip id="tooltip-restart">{this.state.audioState.repeat?'Track Repeated':'Repeat Track'}</Tooltip>
															}><FontAwesomeIcon icon="repeat" style={{color:this.state.audioState.repeat?'#00b9fb':'#ffffff'}} />
														</OverlayTrigger>
													</li>
													{this.state.audiodata.uid>0&&
														<li className="audio-cursor">
															<OverlayTrigger key="user" placement="top" overlay={
																	<Tooltip id="tooltip-user">View DJ Profile</Tooltip>
																}><Link to={`/${this.state.audiodata.username.toLowerCase().replaceAll(' ','_')}`}><FontAwesomeIcon icon="user" style={{color:'#ff8c00'}} /></Link>
															</OverlayTrigger>
														</li>
													}
													<li className="audio-cursor" onClick={this.audioFavorite}>
														<OverlayTrigger key="favorite" placement="top" overlay={
																<Tooltip id="tooltip-favorite">{user.user.user.rank===1?'Login to set Favorite':'Favorite'}</Tooltip>
															}><FontAwesomeIcon icon="heart" style={{color:user.user.user.rank>1?this.state.audioState.favorite?'#ff1493':'#ffffff':'#ffffff'}} />
														</OverlayTrigger>
													</li>
													<li className="audio-cursor" onClick={this.audioLike}>
														<OverlayTrigger key="thumbs-up" placement="top" overlay={
																<Tooltip id="tooltip-thumbs-up">{user.user.user.rank===1?'Login to set Like':'Like'}</Tooltip>
															}><FontAwesomeIcon icon="thumbs-up" style={{color:user.user.user.rank>1?this.state.audioState.like?'#00b9fb':'#ffffff':'#ffffff'}} />
														</OverlayTrigger>
													</li>
												</ul>
											</div>
										</Row>
									</div>

									<div className="col-8 col-lg-4 text-vertical socketplayer-showname" style={{position: 'relative'}}> {/**/}
										<Row className="gx-0" style={{width: '100%'}}>
											<div className="" style={{width: 70}}>
												{this.displayTime(this.state.audioState.currentTime)}
											</div>
											<Col className="socketplayer-track">
												<span className="socketplayer-track1" style={{width: `100%`}}>&nbsp;</span>
												<span className="socketplayer-track2" style={{width: `${this.state.audioState.currentTime/this.state.audioState.duration*100}%`}}></span>
												<OverlayTrigger key="track-seek" placement="top" overlay={
														<Tooltip id="tooltip-track-seek">{user.user.user.rank < 4 ?'Seeking not Available':`Seek Track ${this.displayTime(this.state.audioPos)}`}</Tooltip>
													}><span className="socketplayer-track3" style={{width: `100%`}} onMouseMove={(e)=>this.audioSeekPos(e)} onClick={(e)=>this.audioSeek(e)}></span>
												</OverlayTrigger>
											</Col>
											<div className="text-right" style={{width: 70}}>
												{this.displayTime(this.state.audiodata.length)}
											</div>
										</Row>
									</div>

									<div className="text-right text-vright socketplayer-showname-overflow" style={{width:100}}>
										<Row className="gx-0">
											<Col>
												<ul className="socketplayer-icongrid">
													<li className="audio-cursor" onMouseOver={()=>this.showVolume(1)} onMouseOut={()=>this.showVolume(0)} style={{display: 'relevant'}}>
														<FontAwesomeIcon icon="volume-high" />
														{this.state.showVolume===1&&
														<div style={{position:'absolute', backgroundColor: 'rgb(25, 17, 45)', bottom: 40, width: 30, height: 100, padding: 10, zIndex: 2000}}>
															<div style={{backgroundColor: 'rgba(0,0,0,1)', position:'absolute', bottom: 10, width: 10, height: '80%', borderRadius: 20}}>
																<div style={{backgroundColor: 'rgba(255,255,255,0.55)', position:'absolute', bottom: 0, width: '100%', height: `${this.state.volume}%`, borderRadius: 20}}>
																</div>
																<div style={{position:'absolute', bottom: 0, width: '100%', height: '100%', borderRadius: 20}} /*onClick={(e)=>this.setVolume(e)}*/ onMouseDown={(e)=>this.setVolumeDown(e)}>
																</div>
																{this.state.volumeDrag &&
																	<div style={{position: 'absolute', backgroundColor: '', left: -200, top: -200, width: 430, height: 500}} onMouseMove={(e)=>this.setVolumeMove(e)} onMouseUp={(e)=>this.setVolumeUp(e)}></div>
																}
															</div>
														</div>
														}
													</li>
													<li className="audio-cursor" onClick={this.audioClose}>
														<OverlayTrigger key="thumbs-close" placement="top" overlay={
																<Tooltip id="tooltip-close">Close</Tooltip>
															}><FontAwesomeIcon icon="xmark" />
														</OverlayTrigger>
													</li>
												</ul>
											</Col>
										</Row>
									</div>
								</Row>
							</div>

						</div>
						<div style={{position:'relative',height: 58}}>

						</div>
					</div>
				}
			</>
		)
	}
}

	